import { render, staticRenderFns } from "./layout-global-menu.vue?vue&type=template&id=fe1f897c&scoped=true&"
import script from "./layout-global-menu.vue?vue&type=script&lang=js&"
export * from "./layout-global-menu.vue?vue&type=script&lang=js&"
import style0 from "./layout-global-menu.vue?vue&type=style&index=0&id=fe1f897c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1f897c",
  null
  
)

export default component.exports